import React from "react";
import { useLanguage } from "../../../../contexts";
import { P, useEnergia } from "../engine";
import { ConInstalacion, Section, StatusBadge } from "../common/SectionCommon";
import "../common/common.scss";

const CLASE_DICTAMEN = { "badge-good": "Cumple", "badge-warn": "Brecha parcial", "badge-bad": "Brecha mayor" };

// Plan de relevamiento en planta: estado de la medición, agenda, muestreo dirigido, lista de control y hoja de ruta.
export function OnSiteWorkPlan({ installation }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const vista = useEnergia(installation);
  return (
    <ConInstalacion installation={installation} vista={vista} t={t}>
      {(f) => {
        const d = P.dictamen(f);
        // el muestreo del prototipo supone que hay meses cargados (en una planta recién creada no los hay)
        let mu = {};
        if ((f._monthly || []).length) { try { mu = P.muestreoDirigido(f); } catch (e) { mu = {}; } }
        const muestras = [...(mu.meses || []), ...(mu.equipos || []), ...(mu.ecm || []), ...(mu.instr || [])];
        const topUse = [...(f.seus || [])].sort((a, b) => (b.share || 0) - (a.share || 0)).slice(0, 3);
        const ruta = P.hojaDeRuta(f);
        return (
          <div className="ep-screen">
            <h3 className="ep-screen__title">{t("energy_performance_onsite_title")}</h3>

            <Section title={t("energy_performance_measurement_status")}>
              <p><StatusBadge estado={CLASE_DICTAMEN[d.cls] || "Pendiente"}>{d.nivel}</StatusBadge></p>
              <p className="ep-section__note">{d.lectura}</p>
            </Section>

            <Section title={t("energy_performance_onsite_agenda")}>
              <div className="ep-table">
                <table>
                  <tbody>{P.agendaEnSitio(f).map((x, i) => <tr key={i}><td className="ep-mono">{x.h}</td><td><strong>{x.b}</strong></td><td className="ep-section__note">{x.d}</td></tr>)}</tbody>
                </table>
              </div>
            </Section>

            <Section title={t("energy_performance_onsite_sampling")} note={t("energy_performance_onsite_sampling_note")}>
              {!muestras.length && <p className="ep-section__note">{t("energy_performance_onsite_no_months")}</p>}
              <div className="ep-table">
                <table>
                  <thead><tr><th>{t("energy_performance_onsite_what")}</th><th>{t("energy_performance_docs_why")}</th></tr></thead>
                  <tbody>{muestras.map((x, i) => <tr key={i}><td><strong>{x.q}</strong></td><td className="ep-section__note">{x.por}</td></tr>)}</tbody>
                </table>
              </div>
            </Section>

            <Section title={t("energy_performance_onsite_checklist")}>
              {topUse.map((u) => {
                const eq = (f.machinery || []).filter((m) => m.seu === u.name).map((m) => ({ m, kwh: P.estimarConsumo(m) || 0 })).sort((a, b) => b.kwh - a.kwh).slice(0, 2);
                return (
                  <div key={u.name}>
                    <p><strong>{u.name}</strong> <span className="ep-section__note">({u.share}% · IDEn: {u.enpi || "—"})</span></p>
                    <ul>
                      {eq.length ? eq.map(({ m }) => (
                        <li key={m.nombre}>☐ <strong>{m.nombre}</strong>: {t("energy_performance_onsite_check_equipment")} <span className="ep-section__note">{t("energy_performance_onsite_compare")}: {P.guiaParaMaquina(m).comparar}</span></li>
                      )) : <li>☐ {t("energy_performance_onsite_check_seu")}</li>}
                    </ul>
                  </div>
                );
              })}
              <p><strong>{t("energy_performance_onsite_transversal")}</strong></p>
              <ul>{["energy_performance_onsite_t1", "energy_performance_onsite_t2", "energy_performance_onsite_t3", "energy_performance_onsite_t4"].map((k) => <li key={k}>☐ {t(k)}</li>)}</ul>
            </Section>

            <Section title={t("energy_performance_roadmap_title")}>
              {!ruta.fases.length && <p className="ep-section__note">{t("energy_performance_gaps_none")}</p>}
              {ruta.fases.map((p) => (
                <div key={p.n}>
                  <p><StatusBadge estado="Pendiente">{t("energy_performance_phase")} {p.n} — {p.t}</StatusBadge></p>
                  <ul>{p.items.map((b, i) => <li key={i}><strong>{b.cl}:</strong> {b.cargar} <span className="ep-section__note">({b.resp})</span></li>)}</ul>
                </div>
              ))}
            </Section>
          </div>
        );
      }}
    </ConInstalacion>
  );
}
